import { render, staticRenderFns } from "./group-handle.vue?vue&type=template&id=7150c8a6&scoped=true"
import script from "./group-handle.vue?vue&type=script&lang=js"
export * from "./group-handle.vue?vue&type=script&lang=js"
import style0 from "./group-handle.vue?vue&type=style&index=0&id=7150c8a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7150c8a6",
  null
  
)

export default component.exports